import Cookies from 'js-cookie'
import {visitorIdKey} from '../config/env'
const TokenKey = visitorIdKey


let isLs = window.localStorage ? 1 : 0;
let shibie = 1;


export function setLocVal(key,value) {
    try {
        window.localStorage[key] = value;
    } catch (err) {
        clearLocVal(key);
        Cookies.set(key, value)
    }
}

export function getLocVal(key) {
    try {
        window.localStorage["1"] = 1;
        var value = window.localStorage[key];
        return value;
    } catch (e) {
        return Cookies.get(key)
    }
}

export function clearLocVal(key) {
    try {
        if (key)
            window.localStorage.removeItem(key);
        else
            window.localStorage.clear();
    } catch (e) {
        Cookies.remove(key)
    }
}


export function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "";

    var uuid = s.join("");
    return uuid;
}

export function getBrowerLang() {
    return (navigator.language || navigator.browserLanguage).toLowerCase();
}

export const getUrlKey=(name)=>{
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}

export function setHzLocalVal(name, value,time) {
    var exp = new Date();
    exp.setTime(exp.getTime() + time *60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

export function wait(time) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, time*1000)
    })
}



export function creatConversionDiv(time) {
    // 查找目标容器
    const targetContainer = document.querySelector('.client-chat');
    // 如果找不到目标容器则不执行
    if (!targetContainer) {
        return;
    }
    // 检查是否已存在conversionLabel元素
    const existingDiv = targetContainer.querySelector('.conversionLabel');
    if (existingDiv) {
        return;
    }
    // 创建div元素
    const newDiv = document.createElement('div');
    newDiv.classList.add('conversionLabel');
    newDiv.textContent = 'conversion'; // 添加文本内容
    newDiv.style.width = '1px';
    newDiv.style.height = '1px';
    newDiv.style.fontSize= '0px';
    // 添加到.client-chat容器内
    targetContainer.appendChild(newDiv);
}
